import { PropsWithChildren } from 'react';
import classes from './index.module.scss';

export function EmptyPlaceHolder({ children }: PropsWithChildren<{}>) {
  return <div className={classes.root}>{children}</div>;
}
